export const variables = {
  scalePartDefaultName: 'Total',
  units: [
    '%', 'да/нет', 'дней', 'млн руб.', 'руб/га', 'руб/голову', 'руб/кг', 'руб/шт',
    'тонн', 'тонн/га', 'руб/тонн', 'м³/тонн', 'кВт.ч/тонн', 'голов/нач.несуш', 'шт.', 'тыс. руб.',
    'млн шт.' , 'тыс. шт.' , 'литр/тонн' , 'га' , 'руб/км' , 'литр/га' , 'литр/100км', 'кг/тонн',
    'кг/га', 'коэфф.', 'кг'
  ],
}